import Card from '@mui/material/Card';
import { CardContent } from '@mui/material';
import { makeStyles } from '@material-ui/styles';
import { useHistory } from 'react-router';
import axios from 'src/utils/axios';
import React, { useEffect, useState } from 'react';
import {
  Backdrop,
  CircularProgress,
  Snackbar,
  Grid,
  Button,
  Divider,
  Typography,
  TextField,
  Box,
  Tooltip,
  IconButton
} from '@material-ui/core';
import Alert from 'src/components/Alert';
import { confirmAlert } from 'react-confirm-alert';
import PlusOneIcon from '@material-ui/icons/PlusOne';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from 'moment';
import { DataGrid } from '@mui/x-data-grid';

const useStyles = makeStyles(theme => ({
  root: {
    fontFamily: 'Segoe UI',
    width: '100%',
    height: '100%'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#FFA500'
  },
  tableCell: {
    border: '1px solid #ddd',
    color: '#fff',
    backgroundColor: '#0033a0',
    align: 'left',
    cursor: 'pointer'
  },
  sortHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  icon: {
    fontSize: '1rem'
  },
  tableHead: {
    overflowWrap: 'break-word'
  }
}));

function SarisDynamicWarranty() {
  const classes = useStyles();
  const history = useHistory();

  const [loading, setLoading] = React.useState(false);
  const [dynamicWarrantyData, setDynamicWarrantyData] = React.useState([]);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [warrantyType, setWarrantyType] = React.useState('');
  const [description, setDescription] = React.useState('');
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });

  useEffect(() => {
    handleGetSarisDynamicWarranty();
  }, []);

  const handleGetSarisDynamicWarranty = () => {
    setLoading(true);
    axios
      .get(`GetSarisDynamicWarranty`)
      .then(response => {
        setLoading(false);
        var data = response.data;
        setDynamicWarrantyData(data);
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };

  const HandleInsertWarrantyType = () => {
    if (warrantyType.length > 10) {
      setresponseMessage('Garanti Tipi 10 karakterden büyük olamaz !');
      setUyariTip('error');
      setUyari(true);
      return;
    }
    setLoading(true);
    axios
      .get(`SetSarisDynamicNewWarranty/${warrantyType}/${description}`)
      .then(response => {
        setLoading(false);
        var data = response.data;
        if (data.ErrorCode == '1000') {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('error');
          setUyari(true);
          return;
        } else {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('success');
          setUyari(true);
          handleGetSarisDynamicWarranty();
          setWarrantyType('');
          setDescription('');
          return;
        }
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };
  const deleteDynamicWarrantyType = (KulKodu, GarantiTipi, Acıklama) => {
    confirmAlert({
      message: 'Silmek istediğinizde emin misiniz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => {
            handleDeleteDynamicWarrantyType(KulKodu, GarantiTipi, Acıklama);
          }
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  const handleDeleteDynamicWarrantyType = (KulKodu, GarantiTipi, Acıklama) => {
    setLoading(true);
    axios
      .get(
        `SetSarisDynamicWarrantyTypeDelete/${KulKodu}/${GarantiTipi}/${Acıklama}`
      )
      .then(response => {
        setLoading(false);
        var data = response.data;
        if (data.ErrorCode == '1000') {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('error');
          setUyari(true);
          return;
        } else {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('success');
          setUyari(true);
          handleGetSarisDynamicWarranty();
          return;
        }
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };

  const SarisDynamicWarrantyDetail = row => {
    const { GARANTI_TIPI, ACIKLAMA, KUL_GARANTI_TIPI } = row;
    history.push(`/WarrantyTypeDetail/${GARANTI_TIPI}/${ACIKLAMA}`);
  };

  const columns = [
    {
      field: 'KUL_GARANTI_TIPI',
      headerName: 'Garanti Tipi',
      width: 300,
      headerAlign: 'center',
      renderCell: params => (
        <span
          style={{
            textDecoration: 'underline',
            cursor: 'pointer',
            color: '#FF9800'
          }}
          onClick={() => SarisDynamicWarrantyDetail(params.row)}
        >
          {params.row.KUL_GARANTI_TIPI}
        </span>
      )
    },
    {
      field: 'ACIKLAMA',
      headerName: 'Açıklama',
      width: 400,
      headerAlign: 'center'
    },
    {
      field: 'SICILNO',
      headerName: 'Kullanıcı Kodu',
      width: 350,
      headerAlign: 'center'
    },
    {
      field: 'ADSOYAD',
      headerName: 'Kullanıcı',
      width: 300,
      headerAlign: 'center'
    },
    {
      field: 'TARIH',
      headerName: 'Oluşturulma Tarihi',
      width: 400,
      headerAlign: 'center',
      sortComparator: (v1, v2) => {
        const date1 = new Date(v1).getTime();
        const date2 = new Date(v2).getTime();
        return date1 - date2;
      },
      renderCell: params => {
        return moment(params.value).format('DD/MM/YYYY HH:mm:ss');
      }
    },
    {
      field: 'Sil',
      headerAlign: 'center',
      renderCell: cellValues => {
        return (
          <Box sx={{ justifyContent: 'center', '& > :not(style)': { m: 1 } }}>
            <Tooltip title="sil">
              <IconButton>
                <DeleteIcon
                  style={{ color: '#FF9800' }}
                  onClick={() =>
                    deleteDynamicWarrantyType(
                      cellValues?.row?.KUL_KODU,
                      cellValues?.row?.GARANTI_TIPI,
                      cellValues?.row?.ACIKLAMA
                    )
                  }
                />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
      width: 100
    }
  ];

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  return (
    <>
      <Snackbar
        open={uyari}
        autoHideDuration={5000}
        onClose={uyariKapat}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={uyariKapat}
          variant={uyariTip}
          message={responseMessage}
        ></Alert>
      </Snackbar>
      <Card sx={{ width: '100%', height: '100%' }}>
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <br></br>
        <br></br>
        <Grid container justifyContent="center">
          <Divider style={{ margin: '1rem' }} />
          <Typography
            align="center"
            style={{
              marginBottom: '1rem',
              color: '#FF9800',
              fontWeight: 'bold',
              fontSize: '1.2rem'
            }}
          >
            Yeni Giriş
          </Typography>
          <Divider style={{ margin: '1rem' }} />
          <Grid container spacing={2}>
            <Grid item xs={3}></Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Garanti Tipi"
                variant="outlined"
                size="small"
                value={warrantyType}
                onChange={e => setWarrantyType(e.target.value)}
              />
            </Grid>
            <Grid item xs={3}></Grid>
            <Grid item xs={3}></Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Açıklama"
                variant="outlined"
                size="small"
                multiline
                rows={4}
                value={description}
                onChange={e => setDescription(e.target.value)}
              />
            </Grid>
            <Grid item xs={3}></Grid>
            <br></br>
            <br></br>
            <Grid item xs={12}></Grid>
            <Grid item xs={3}></Grid>
            <Grid item xs={6}>
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                startIcon={<PlusOneIcon />}
                onClick={() => {
                  HandleInsertWarrantyType();
                }}
              >
                Ekle
              </Button>
            </Grid>
            <Grid item xs={3}></Grid>
          </Grid>
        </Grid>
        <br></br>
        <br></br>
        <br></br>
        <CardContent>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <DataGrid
                rows={dynamicWarrantyData || []}
                columns={columns}
                getRowId={rows => rows.GARANTI_TIPI}
                sx={{
                  height: 600,
                  width: '100%',
                  '& .MuiDataGrid-cell': {
                    textAlign: 'center',
                    justifyContent: 'center'
                  }
                }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}

export default SarisDynamicWarranty;
